<template>
    <v-icon
        v-if="isLoggedIn"
        :icon="mdiAccountCircle"
        :size="size"
    ></v-icon>
    <v-icon
        v-else
        :icon="mdiAccountCircleOutline"
        :size="size"
    ></v-icon>
</template>

<script lang="ts" setup>
    import { mdiAccountCircle, mdiAccountCircleOutline } from '@mdi/js';

    withDefaults(
        defineProps<{
            size?: Undefinable<number | string>;
        }>(),
        {
            size: undefined
        }
    );

    const nuxtApp = useNuxtApp();
    const { isLoggedIn } = nuxtApp.$user;
</script>

<style lang="scss"></style>
